<template>
    <div>
        <AnalyticsHeader />
        <div class="container mt-4">
            <Loader />
            <AnalyticsStatistics />
            <AnalyticsGraphic />
            <AnalyticsPaymentSystemGroup />
        </div>
    </div>
</template>

<script>
    import AnalyticsHeader from "./AnalyticsHeader";
    import AnalyticsGraphic from "./AnalyticsGraphic";
    import AnalyticsPaymentSystemGroup from "./AnalyticsPaymentSystemGroup";
    import AnalyticsStatistics from "./AnalyticsStatistics";
    import Loader from "./Loader";

    import Chart from 'chart.js';

    export default {
        name: "Analytics",
        components: {
            AnalyticsStatistics,
            AnalyticsPaymentSystemGroup,
            AnalyticsGraphic,
            AnalyticsHeader,
            Loader,
        }
    }
</script>
